document.addEventListener('DOMContentLoaded', function() {
    const addToCartButton = document.querySelector('.certificate-modal');    
    const modalBox = document.querySelector('#certificate-modal-box');
    const siteOverlay = document.querySelector('.site-overlay');

    //  Extracting product form
    const addToCartForm = addToCartButton.closest('form');


    // Set variant image when varinat changes
    addToCartForm.addEventListener('change', displayVariantImage);
    
    // Add product to cart
    addToCartButton.addEventListener('click', function(e) {
        e.preventDefault();

        // Setting overlay
        siteOverlay.classList.remove('site-overlay--hidden');

        modalBox.classList.add('certificate-modal-active');

        addToCart(addToCartForm)
        .then(() => {
            return fetch("/cart.json")
        })
        .then(response => {
            if (!response.ok) {
                throw new Error('Error fetching cart data')
            }
            return response.json();
        })
        .then(cart => {
            // Update cart count
            document.querySelectorAll('[data-bind="itemCount"]').forEach(el => {
                el.textContent = cart.item_count;
                if (cart.item_count > 0) {
                }
            });
        })

    });

    // Closing modal
    document.querySelectorAll('.close-modal, .product').forEach(el => {
        el.addEventListener('click', () => {
            modalBox.classList.remove('certificate-modal-active');
            // Remove overlay
            siteOverlay.classList.add('site-overlay--hidden');
        })
    })

    // Stop propogation when clicking on modal box
    document.querySelectorAll('#certificate-modal-box, .certificate-modal').forEach(el => {
        el.addEventListener('click', (e) => {
            e.stopPropagation();
        })
    })
});

function addToCart(productForm) {
    // Convert form to FormData object
    const formData = new FormData(productForm);

    // Add products to cart
    return fetch('/cart/add.js', {
        method: 'POST',
        body: formData
    })
    .then(response => {
        if (!response.ok) {
            throw new Error('Network response was not ok');
        }
        return response.json();
    })
    .catch(error => {
        console.error('There was a problem with the fetch operation:', error.message);
        // Handle any errors that occur during the fetch here
    });
}

// Display right variant image in modal box
function displayVariantImage() {
    // Get variant id from url parameter
    const urlParams = new URLSearchParams(window.location.search);
    const variantIdFromUrl = urlParams.get('variant');

    const variantImages = document.querySelectorAll('.modal_variant_image');

    variantImages.forEach(img => {
        if (img.getAttribute('variant-id') === variantIdFromUrl) {
            img.style.display = "block";
        } else {
            img.style.display = "none";
        }
    })
    
}


    